export default {
  releaseHash: '5127ee5',
  buildNumber: 30
};
